import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'localeCurrency',
})
export class LocaleCurrencyPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    private static readonly symbolToCode = new Map<string, string>([
        ['\u20AC', 'EUR'],
        ['$', 'USD'],
        ['\u00A3', 'GBP'],
        ['\u00A5', 'JPY'],
        ['\u20B9', 'INR'],
        ['\u20A9', 'KRW'],
        ['\u20BD', 'RUB'],
        ['\u20BA', 'TRY'],
        ['\u20BF', 'BTC'],
        ['Fr', 'CHF'],
        ['kr', 'SEK'],
        ['R$', 'BRL'],
        ['z\u0142', 'PLN'],
        ['K\u010D', 'CZK'],
    ]);

    transform(value: number | string | null | undefined, currencyCode: string = ''): string {
        if (value == null || value === '') {
            return '';
        }

        const num = typeof value === 'string' ? parseFloat(value) : value;

        if (Number.isNaN(num)) {
            return '';
        }

        const locale = navigator.language || 'en-US';
        const formatted = new Intl.NumberFormat(locale, {
            maximumFractionDigits: 0,
        }).format(num);

        const code = LocaleCurrencyPipe.symbolToCode.get(currencyCode) || currencyCode;

        return code ? `${formatted} ${code}` : formatted;
    }
}
